<template>
  <div class="locale-switcher">
    <v-btn
      id="lang-switch"
      size="small"
      class="on-surface"
      density="comfortable"
    >
      <v-icon start>$mdiWeb</v-icon>
      {{ $t("site.lang_" + language) }}
      <v-icon size="small" end>$mdiMenuDown</v-icon>
    </v-btn>
    <v-menu
      activator="#lang-switch"
      overflow-y-scroll
      location="left top"
      style="z-index: 22224"
    >
      <v-list density="compact">
        <v-list-item
          v-for="locale in locales"
          :key="locale.id"
          :class="{ 'v-list-item--active': locale === language }"
          @click="setLocale(locale)"
        >
          <v-list-item-title>
            {{ $t("site.lang_" + locale) }}</v-list-item-title
          >
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script setup>
// Restore locale from state/localStorage, if it was set

import { useSiteStore } from "@/stores/site";
import { computed } from "vue";
import { useLocale } from "vuetify";

const props = defineProps({
  locales: {
    type: Array,
    default: () => ["en", "de", "nl"],
  },
});

const siteStore = useSiteStore();
const language = computed(() => siteStore.language);

const { current } = useLocale();
current.value = language.value;

const setLocale = function (locale) {
  siteStore.setLanguage(locale);
  console.log("New locale = " + locale);
  current.value = locale;
};
</script>
